import {
  changeQuestionClearOnHide,
  getQuotationIsFromRenewal,
  setQuestionVisibility,
} from 'app/services/businessFunctionHelpers';
import { FieldsEnum, FormsEnum } from 'app/shared/enums';

const nightParkingPlace = {
  nightParkingPlaceChange() {
    const isFromRenewal = getQuotationIsFromRenewal();

    if (isFromRenewal) {
      changeQuestionClearOnHide(
        FieldsEnum.PlannedUsageNightParkingPlace,
        FormsEnum.CalculationForm,
        false
      );

      setQuestionVisibility({
        key: FieldsEnum.PlannedUsageNightParkingPlace,
        visible: false,
        formName: FormsEnum.CalculationForm,
      });
    }
  },
};

export default nightParkingPlace;
